// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2u3ue","header":"ClearentDisclaimer_header__3oNdp","inner":"ClearentDisclaimer_inner__gDOaD"};